export default __webpack_public_path__ + "static/media/founder2.fc643f7b.jpeg";